var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTwygs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 56,
    viewBox: "0 0 207 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2120_4009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.511 9.70172L121.639 44.0991C119.876 48.498 117.672 51.5772 115.043 53.3468C112.414 55.1103 109.192 55.9981 105.368 55.9981C103.477 55.9981 101.577 55.7189 99.6651 55.1646C97.7529 54.6062 96.2465 53.877 95.1337 52.9732L99.7575 43.4182C100.453 43.9545 101.248 44.3823 102.13 44.7118C103.011 45.0412 103.867 45.2099 104.689 45.2099C106.211 45.2099 107.362 44.756 108.139 43.8521L100.916 26.4515C98.9641 21.7493 92.2393 21.9482 90.5681 26.7568L84.7793 43.4182H71.2152L66.1033 27.8214L60.8006 43.4182H47.2364L35.5303 9.69971H48.7168L54.5136 27.5161L60.5555 9.69971H72.3882L78.2453 27.7009L80.3825 21.3316C82.7145 14.3818 89.2264 9.69971 96.5578 9.69971C103.612 9.69971 109.939 14.0423 112.478 20.6245L115.23 27.7611L122.318 9.69971H135.511V9.70172Z",
    fill: "url(#paint0_linear_2120_4009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.943 9.70545V36.7052C171.943 43.1146 170.165 47.9333 166.61 51.1591C163.055 54.3849 157.989 55.9979 151.415 55.9979C148.044 55.9979 144.901 55.6383 141.984 54.9192C139.066 54.2002 136.579 53.1617 134.526 51.8059L139.21 42.3132C140.526 43.2994 142.189 44.1009 144.204 44.7175C146.217 45.3342 148.149 45.6415 149.999 45.6415C152.793 45.6415 154.827 45.0449 156.101 43.8538C157.374 42.6627 158.011 40.9152 158.011 38.6154V37.9987C155.916 40.3829 152.813 41.574 148.703 41.574C145.827 41.574 143.145 40.9072 140.659 39.5715C138.172 38.2357 136.19 36.3255 134.711 33.8389C133.231 31.3542 132.492 28.508 132.492 25.3023C132.492 22.0966 133.231 19.2604 134.711 16.7958C136.192 14.3293 138.172 12.4291 140.659 11.0934C143.145 9.75768 145.827 9.09082 148.703 9.09082C153.305 9.09082 156.633 10.5692 158.69 13.5278V9.70545H171.943ZM156.503 29.2151C157.591 28.2088 158.136 26.9032 158.136 25.3003C158.136 23.6974 157.591 22.4039 156.503 21.4177C155.414 20.4314 154.046 19.9373 152.403 19.9373C150.76 19.9373 149.33 20.4314 148.241 21.4177C147.153 22.4039 146.608 23.6974 146.608 25.3003C146.608 26.9032 147.163 28.2088 148.271 29.2151C149.38 30.2234 150.758 30.7255 152.401 30.7255C154.044 30.7255 155.41 30.2234 156.501 29.2151H156.503Z",
    fill: "url(#paint1_linear_2120_4009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.325 43.1146C177.529 42.4979 175.271 41.6965 173.544 40.7103L177.366 31.5249C178.927 32.471 180.777 33.2101 182.914 33.7444C185.051 34.2787 187.126 34.5459 189.141 34.5459C190.743 34.5459 191.862 34.4133 192.501 34.1461C193.138 33.879 193.457 33.4793 193.457 32.945C193.457 32.4107 193.057 32.0411 192.256 31.8362C191.454 31.6314 190.149 31.4245 188.341 31.2196C185.587 30.8902 183.245 30.4704 181.315 29.9562C179.383 29.444 177.687 28.4457 176.229 26.9674C174.771 25.489 174.042 23.372 174.042 20.6182C174.042 18.4408 174.699 16.4885 176.014 14.7631C177.328 13.0377 179.29 11.6598 181.902 10.6334C184.511 9.60698 187.644 9.09277 191.302 9.09277C193.849 9.09277 196.345 9.32979 198.792 9.80181C201.236 10.2738 203.323 10.9648 205.049 11.8667L201.226 21.052C198.268 19.409 195.02 18.5855 191.487 18.5855C188.446 18.5855 186.925 19.1197 186.925 20.1883C186.925 20.7226 187.335 21.1022 188.158 21.3292C188.98 21.5562 190.273 21.7711 192.041 21.976C194.793 22.3054 197.127 22.7372 199.037 23.2715C200.947 23.8058 202.632 24.8121 204.091 26.2925C205.549 27.7708 206.28 29.8879 206.28 32.6417C206.28 34.7367 205.623 36.6489 204.308 38.3743C202.992 40.0997 201.019 41.4776 198.39 42.504C195.759 43.5304 192.575 44.0446 188.835 44.0446C185.959 44.0446 183.123 43.7372 180.329 43.1206L180.325 43.1146Z",
    fill: "url(#paint2_linear_2120_4009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3299 31.501C23.3299 32.5214 23.597 33.3228 24.1253 33.8973C24.6596 34.4677 25.3526 34.7529 26.2143 34.7529C27.4013 34.7529 28.4438 34.4496 29.3457 33.833L32.6579 43.4723C30.5749 44.6534 27.7267 45.2479 24.1273 45.2479C19.4231 45.2479 15.8036 44.1171 13.2648 41.8453C10.7259 39.5736 9.46045 36.165 9.46045 31.6255V26.7386C9.46045 23.5811 12.0194 21.0221 15.1769 21.0221H19.5798C21.014 21.0221 22.3216 20.4617 23.2857 19.5458C23.3178 19.5136 23.354 19.4775 23.3922 19.4453C24.3663 18.4651 24.9689 17.1234 24.9689 15.633C24.9689 14.1426 24.3201 12.6944 23.2857 11.7102C22.3196 10.7943 21.014 10.2379 19.5798 10.2379H15.1769C12.0194 10.2379 9.46045 7.67891 9.46045 4.52138V0H23.2857V3.62353C23.2857 7.27518 26.2424 10.2379 29.9 10.2379C31.3804 10.2379 32.7703 10.8445 33.7867 11.8207C34.8071 12.7948 35.4518 14.1426 35.4559 15.625C35.4559 17.1194 34.8533 18.4671 33.8691 19.4473C32.8989 20.4215 31.5471 21.0241 30.0567 21.0241H29.9824C26.3267 21.0241 23.3681 23.9868 23.3681 27.6385L23.3319 31.503L23.3299 31.501Z",
    fill: "url(#paint3_linear_2120_4009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55581 21.1605C8.6242 21.1605 11.1116 18.673 11.1116 15.6046C11.1116 12.5363 8.6242 10.0488 5.55581 10.0488C2.48742 10.0488 0 12.5363 0 15.6046C0 18.673 2.48742 21.1605 5.55581 21.1605Z",
    fill: "url(#paint4_linear_2120_4009)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2120_4009",
    x1: 154.406,
    y1: -18.6719,
    x2: 36.7957,
    y2: 55.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2120_4009",
    x1: 176.761,
    y1: 16.5628,
    x2: 59.1534,
    y2: 91.1867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2120_4009",
    x1: 185.129,
    y1: 29.7493,
    x2: 67.5213,
    y2: 104.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2120_4009",
    x1: 134.408,
    y1: -50.1871,
    x2: 16.7999,
    y2: 24.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D38D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2120_4009",
    x1: 127.185,
    y1: -61.5721,
    x2: 9.57703,
    y2: 13.0537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D38D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2120_4009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.276,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTwygs);
export default __webpack_public_path__ + "static/media/logo-twygs.ff0334e1902441d3f5fd195ee90a41f8.svg";
export { ForwardRef as ReactComponent };